import { Directive, ElementRef, OnDestroy, effect, inject, input } from '@angular/core';
import { TourService } from '../services/tour.service';

/**
 * Registers the host element as a tour anchor under a string key.
 *
 * Usage:
 *   <a [appTourTarget]="'manual-nav'" routerLink="/manual">...</a>
 *
 * Empty / null key = no-op (useful inside @for loops where only one item should be a target).
 */
@Directive({
  selector: '[appTourTarget]',
  standalone: true,
})
export class TourTargetDirective implements OnDestroy {
  readonly appTourTarget = input.required<string>();

  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly tour = inject(TourService);
  private registeredKey: string | null = null;

  constructor() {
    effect(() => {
      const key = this.appTourTarget();
      if (this.registeredKey && this.registeredKey !== key) {
        this.tour.unregisterAnchor(this.registeredKey, this.el.nativeElement);
        this.registeredKey = null;
      }
      if (key && !this.registeredKey) {
        this.tour.registerAnchor(key, this.el.nativeElement);
        this.registeredKey = key;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.registeredKey) {
      this.tour.unregisterAnchor(this.registeredKey, this.el.nativeElement);
      this.registeredKey = null;
    }
  }
}
